/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./twinTable.vue?vue&type=template&id=7403068a"
import script from "./twinTable.vue?vue&type=script&lang=js"
export * from "./twinTable.vue?vue&type=script&lang=js"
import style0 from "./twinTable.vue?vue&type=style&index=0&id=7403068a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports